import React from 'react';

const Play = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C3.13412 0 0 3.13412 0 7C0 10.8659 3.13412 14 7 14C10.8659 14 14 10.8659 14 7C14 3.13412 10.8659 0 7 0ZM5.093 3.5842C5.23132 3.58104 5.3743 3.61518 5.51364 3.6908L10.0008 6.28768C10.245 6.42954 10.4102 6.68987 10.4102 6.99445C10.4102 7.29893 10.245 7.55936 10.0008 7.70122L5.51364 10.3038C4.95598 10.6061 4.32184 10.221 4.30776 9.58583V4.40322C4.31833 3.9269 4.67812 3.59366 5.093 3.5843V3.5842Z"
      fill="white"
    />
  </svg>
);

export default Play;
